import styled from 'styled-components';
import React from 'react';
import { ContentfulImageAsset } from '../../interfaces/ContentfulImageAsset';
import { breakpoint } from '../../theme';

const PictureWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const PicturePanelContainer = styled.section`
  max-height: 810px;
  width: 100%;

  ${breakpoint('xs', 'md')`
    .mobileImage{
      display: block;
    }
  `}

  ${breakpoint('md')`
    .desktopImage{
      display: block;
    }
  `}
`;

const StyledImage = styled.img`
  aspect-ratio: 16 / 9;
  width: 100%;
  display: none;
  object-fit: cover;
`;

export interface PicturePanelProps {
  label: string;
  desktopAsset: ContentfulImageAsset;
  mobileAsset?: ContentfulImageAsset;
  altText: string;
}

export const PicturePanel: React.FC<PicturePanelProps> = (
  data
): React.ReactElement => {
  return (
    <PictureWrapper>
      <PicturePanelContainer>
        {/* Next/Image does not help us if we do not know a fixed dimensions for the image or its parent container.
        Our requirement is to maintain a responssive 16:9 aspect ratio for the image without fixed dimensions */}
        <StyledImage
          src={data.desktopAsset.url}
          alt={data?.altText}
          className="desktopImage"
        />
        <StyledImage
          src={
            data.mobileAsset && data.mobileAsset.url
              ? data.mobileAsset.url
              : data.desktopAsset.url
          }
          alt={data?.altText}
          className="mobileImage"
        />
      </PicturePanelContainer>
    </PictureWrapper>
  );
};
